export default {
  booking_confirmation_title: 'Potvrda rezervacije',
  booking_confirmation_body: 'Hvala vam na rezervaciji. Podaci o potvrdi su navedeni u nastavku.',
  location: 'Lokacija',
  pickup_location: 'Lokacija preuzimanja',
  dropoff_location: 'Lokacija odredišta',
  vehicle: 'Vozilo',
  pickup_and_dropoff: 'Preuzimanje i odredište (lokalno vrijeme)',
  distance_allowance: 'Dozvoljena razdaljina',
  view_voucher: 'Prikaži vaučer',
  view_more_bookings: 'Prikaži još rezervacija',
  identity_verification_body: 'Od vas će se zahtijevati da potvrdite svoj identitet prije nego što preuzmete vozilo',
  identity_verification_title: 'Potvrda identiteta',
  search_again: 'Pretraži ponovo',
  aircon: 'klima uređaj',
  refrigeration: 'U hladnjaku',
  not_available: 'Drive &amp; Go je trenutno dostupno samo za osobe sa dokumentima o identitetu i vozačkom dozvolom iz {profiles}, ali stalno dodajemo još zemalja.',
  check_if_included: 'Provjerite da li je vaša zemlja navedena.',
  included_in_booking: 'Uključeno u ovu rezervaciju',
  cdw_with_excess: 'CDW sa prekoračenjem',
  theft_protection: 'Zaštita od krađe sa prekoračenjem',
  risk_reduction: 'Smanjenje rizika',
  free_extras: 'Imate pravo na dvije besplatne dodatne usluge <br /> uz ovu rezervaciju.',
  total_cost: 'Ukupna cijena iznajmljivanja',
  continue: 'Nastavi',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'veliki',
  luggage_medium_long_label: 'srednji',
  luggage_small_long_label: 'mali',
  fuel_unspecified_label: 'neodređeno',
  transmission_manual_label: 'Ručni',
  transmission_automatic_label: 'Automatski',
  make_a_booking: 'Napravi rezervaciju',
  pickup_date: 'Datum preuzimanja',
  dropoff_date: 'Datum dolaska na odredište',
  driver_age: 'Vozač između 30 – 65',
  enter_driver_age: 'Unesite starost vozača',
  promo_code: 'Promotivni kôd',
  search: 'Pretraga',
  dropoff_date_cannot_be_before_pickup_date: 'Datum dolaska na odredište ne može da bude raniji od datuma preuzimanja',
  pickup_date_cannot_be_in_the_past: 'Datum preuzimanja ne može da bude u prošlosti',
  pickup_time_cannot_be_in_the_past: 'Vrijeme preuzimanja ne može da bude u prošlosti',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Vrijeme dolaska na odredište mora da bude kasnije od vremena preuzimanja ako je istog dana',
  vehicle_filters: 'Filteri za vozilo',
  reset: 'Resetuj',
  transmission: 'Mjenjač',
  all: 'Sve',
  manual: 'Ručni',
  auto: 'Automatski',
  passengers: 'Broj putnika',
  vehicle_type: 'Tip vozila',
  filter: 'Filter',
  vehicle_search: 'Pretraga vozila',
  edit: 'Uredi',
  no_results: 'Nema rezultata koji odgovaraju zadatim kriterijumima.',
  small_cars: 'Mali automobili',
  medium_cars: 'Srednji automobili',
  large_cars: 'Veliki automobili',
  estate_cars: 'Karavani',
  suvs: 'Terenski automobili',
  mpvs: 'Višenamjenska vozila',
  vans: 'Kombi',
  camper_vans: 'Kamperi',
  premium: 'Premium',
  unspecified: 'neodređeno',
  large: 'veliki',
  medium: 'srednji',
  small: 'mali',
  automatic: 'automatski',
  you_have_been_refunded: 'Refundacija je izvršena.',
  please_customer_service: 'Da biste napravili rezervaciju, obratite se korisničkoj službi.',
  contact_customer_service: 'Kontaktiraj korisničku službu',
  booking_failed: 'Rezervacija trenutno ne može da se obradi.',
  summary: 'Rezime',
  reforestation_and_protection: 'Podržite pošumljavanje i zaštitu kišnih šuma širom Kostarike',
  cost_of_rental: 'Cijena iznajmljivanja',
  to_pay_now: 'Plaća se odmah',
  pay_on_arrival: 'Plaća se po dolasku',
  greenheart_donation: 'Donacija za zaštitu prirode',
  tc_agreement: 'Pročitao/la sam i razumijem {0}.',
  tc: 'Uslovi i odredbe',
  receive_offers: 'Želim da primam posebne ponude putem e-pošte.',
  donate: 'Da, želim da doniram za {amount}',
  pay_now: 'Platite {amount} odmah',
  driver_details: 'Podaci o vozaču',
  complete_driver_details: 'Popunite podatke o vozaču.',
  are_you_the_driver: 'Da li ste vi vozač?',
  have_an_account: 'Da li imate nalog?',
  login: 'Prijavljivanje',
  or: 'ili',
  first_name: 'Ime vozača',
  last_name: 'Prezime vozača',
  email: 'E-adresa',
  phone_number: 'Broj mobilnog telefona',
  unable_to_save_driver_information: 'Informacije o vozaču nisu sačuvane. Pokušajte ponovo.',
  pay_on_arrival: 'Plaćanje po dolasku',
  pay_online_now: 'Platite onlajn odmah',
  day: 'Dan',
  choose_location: 'Odaberite lokaciju',
  pickup_location: 'Lokacija preuzimanja',
  dropoff_location: 'Lokacija odredišta',
  location_not_found: 'Zahtijevana lokacija nije pronađena.',
  add: 'Dodaj',
  remove: 'Ukloni',
  free_extra: 'Besplanta dodatna usluga',
  free: 'BESPLATNO!',
  fast_track_notice: 'Na ovu uslugu se primjenjuju ograničenja za porijeklo dokumenta. Dostupno je samo za osobe sa dokumentima iz',
  complete_booking: 'Završi rezervaciju',
  choose_card: 'Odaberite karticu ili dodajte novu.',
  add_billing_details: 'Dodaje podatke o plaćanju.',
  card_number: 'Broj kartice',
  card_holder_name: 'Ime vlasnika kartice',
  card_exp: 'MM / GG',
  card_cvc: 'CVC',
  save_card: 'Sačuvati karticu?',
  amount_charged: 'Izvršiće se naplata preko kartice',
  payment_confirmation: 'Potvrda rezervacije i plaćanje',
  payment_methods: 'dostupni načini plaćanja',
  use_saved_card: 'x upotrebi sačuvanu karticu',
  use_different_card: '+ upotrebi drugu karticu',
  book_now: 'Rezerviši odmah',
  minimum_age: 'Samo preko {age}',
  excess_liability: 'Dozvoljeno prekoračenje',
  security_deposit: 'Sigurnosni depozit',
  fuel_policy: 'Pravilo o gorivu',
  like_for_like: 'Sviđanje za sviđanje',
  full_to_full: 'Od punog do punog',
  miles_per_rental: '{mileage} besplatnih milja po iznajmljivanju',
  km_per_rental: '{mileage} besplatnih kilometara po iznajmljivanju',
  unlimited: 'Neograničeno',
  unlimited_mileage: 'Neograničene milje',
  unlimited_mileage_km: 'Neograničena kilometraža',
  non_amendable: 'Bez ispravke',
  non_refundable: 'Bez refundacije',
  free_cancellation_until: 'Besplatno otkazivanje do',
  cancellation_in_line_with: 'Otkazivanje je u skladu sa',
  tcs: 'Uslovima i odredbama',
  free_extras_on_collection: 'Dvije besplatne dodatne usluge po preuzimanju',
  glass_and_tyres_covered: 'Staklo i gume su uključeni',
  number_of_passengers: 'Broj putnika',
  number_of_bags: 'Broj torbi',
  fuel_type: 'Tip goriva',
  co2: 'CO2',
  aircon: 'Klima uređaj',
  book_type: 'Rezerviši {type}',
  processing: 'Obrada je u toku',
  actual_price: 'Stvarna cijena',
  tooltip: 'Cijena u {currencyCode} USD je procjena na osnovu kursa, cijena u {currency} USD je obavezujuća.',
  deposit: 'Depozit',
  pay_online: 'Platite onlajn odmah',
  pay_online_without_extras: 'Cijena iznajmljivanja',
  extras_on_arrival: 'Dodatne usluge po dolasku',
  insurance_on_arrival: 'Smanjenje rizika – Plaćanje po dolasku',
  insurance_online: 'Smanjenje rizika – Plaćanje odmah',
  extras_online: 'Dodatne usluge se plaćaju odmah',
  green_heart_donation: 'Donacija za Green Heart zaštitu prirode',
  my_profile: null,
  aircon_lower: 'klima-uređaj',
  why_use_drive_and_go: 'Zašto treba da koristite Drive & Go?',
  straight_to_car: 'Vodimo vas pravo do automobila',
  no_queues: 'Nema čekanja',
  self_checkout: 'Možete sami da dovršite postupak iznajmljivanja',
  cant_lose_key: 'Ne možete da izgubite ključ',
  online_id_check: 'Provjera identifikacionog dokumenta na internetu',
  phone_as_key: 'Telefon sa ulogom ključa',
  premiumplus_benefits_includes: 'Ujedno su obuhvaćene Premium Plus+ pogodnosti',
  book_drive_go: 'Rezervišite Drive & Go',
  duration: 'Trajanje',
  to_pay_on_arrival: 'Plaćanje po dolasku',
  return_date: 'Datum povratka',
  additional_options: 'Dodatne opcije',
  booking_details: 'Detalji o rezervaciji',
  price_for_x_days: 'Cijena za {qty_of_days} dan | Cijena za {qty_of_days} dana',
  cancelled: 'Otkazano',
  upcoming: 'Predstojeće',
  active: 'Aktivno',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go je trenutno dostupno samo za osobe sa dokumentima o identitetu i vozačkom dozvolom iz sljedećih zemalja:',
    drive_and_go_today: 'Drive & Go rezervacija već danas!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Zašto treba da koristite Drive & Go?',
    straight_to_car: 'Vodimo vas pravo do automobila',
    no_queues: 'Nema čekanja',
    self_checkout: 'Možete sami da dovršite postupak iznajmljivanja',
    cannot_lose_the_key: 'Ne možete da izgubite ključ',
    online_id_check: 'Provjera identifikacionog dokumenta na internetu',
    phone_as_a_key: 'Telefon sa ulogom ključa',
    premium_plus_benefits_also_included: 'Ujedno su obuhvaćene Premium Plus+ pogodnosti',
    book_drive_and_go: 'Rezervišite Drive & Go'
  },
  my_bookings: "My booking",
  no_bookings: "No booking",
  no_bookings_to_display: 'Nema rezervacija za prikaz.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Brojač kilometara pri preuzimanju',
  fuel_at_collection: 'Gorivo pri preuzimanju',
  start_check_in: 'Pokreni prijavljivanje',
  start_collection: 'Pokreni preuzimanje',
  recent_bookings: 'Nedavne rezervacije',
  damage: {
    updated_damage_report_submitted: 'Ažurirani izvještaj o šteti je proslijeđen. Član našeg tima korisničke službe će vas uskoro kontaktirati.',
    add_additional_damage: 'Dodaj dodatno oštećenje',
    you_may_report_additional_damage_up_to: 'Dodatno oštećenje možete da prijavite do 24 časa nakon odjavljivanja vozila',
    specify_damage: 'Navedite oštećenje',
    please_choose_the_area_and_type_of_damage: 'Odaberite oštećenu površinu i vrstu oštećenja',
    type_of_damage: 'Vrsta oštećenja',
    is_this_more_than_5_cm: 'Da li oštećenje zahvata više od 5 cm?',
    please_take_or_select_a_photo: 'Snimite ili izaberite fotografiju',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Snimite fotografiju vodeći računa da je oštećenje jasno vidljivo',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Po potrebi možete da dodate još neku fotografiju, izaberite ikonu da biste dodali fotografiju',
    save_image: 'Sačuvaj sliku',
    save_images: 'Sačuvaj slike',
    damage_saved_successfully: 'Oštećenje je uspješno sačuvano',
    add_photo: 'Dodaj fotografiju'
  },
  checkout: {
    start_collection: 'Pokreni preuzimanje',
    collect_vehicle: 'Preuzmite vozilo',
    we_will_let_you_know_the_details: 'Obavijestićemo vas o lokaciji i detaljima da bismo vam omogućili da pronađete iznajmljeno vozilo.',
    inspect: 'Provjera',
    we_will_ask_for_four_photos_from_each_corner: 'Zatražićemo vam po jednu fotografiju vozila iz sva četiri ugla, kao i svakog novog oštećenja koje nije već navedeno.',
    fuel_and_milage: 'Količina goriva i kilometraža',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Potvrđujete vrednosti kilometraže i količine goriva na početku iznajmljivanja vozila.',
    sign: 'Potpisivanje',
    sign_the_rental_agreement: 'Potpišite ugovor o iznajmljivanju.',
    away_you_go: 'Možete da krenete',
    you_are_free_to_take_to_the_road: 'Sada možete da započnete put!',
    collect_your_vehicle: 'Preuzmite vozilo',
    get_directions: 'Traži putokaz',
    hide_directions: 'Sakrij putokaz',
    local_time: 'lokalno vrijeme',
    tel: 'Tel.',
    getting_to_the_location: 'Dolazak do lokacije',
    get_vehicle_details: 'Pronađi detalje o vozilu',
    view_map: 'Prikaži mapu',
    unlock_vehicle_and_continue: 'Otključaj vozilo i nastavi',
    unable_to_connect_to_vehicle: 'Povezivanje sa vozilom nije moguće',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Nismo uspjeli da se povežemo sa vozilom, provjerite da li ste u neposrednoj blizini vozila i pokušajte ponovo.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nismo uspjeli da pronađemo rezervaciju vozila. Pokušajte ponovo kasnije.',
    odometer_and_fuel: 'Kilometraža i količina goriva',
    odometer: 'Kilometraža',
    please_confirm_the_odometer_and_fuel_readings: 'Potvrdite vrednosti kilometraže i količine goriva.',
    the_odometer_field_is_required: 'Polje kilometraže je obavezno',
    and_must_be_greater_than_the_checkout_odometer: 'i mora da je veće od kilometraže pri završetku postupka iznajmljivanja',
    confirm: 'Potvrdi',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Snimite fotografiju vozila iz sva četiri ugla',
    pre_existing_damage: 'Postojeće oštećenje',
    no_pre_existing_damage: 'Nema postojećeg oštećenja.',
    new_damage: 'Novo oštećenje',
    add_additional_damage: 'dodaj novo oštećenje',
    no_new_damage_to_report: 'Nema novog oštećenja za prijavljivanje',
    checkout_complete: 'Postupak iznajmljivanja je dovršen',
    start_rental: 'Pokreni iznajmljivanje',
    congratulations_name_it_is_time_to_take_to_the_road: 'Čestitamo, {customer_name}, sada možete da započnete put!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Nismo uspjeli da završimo postupak iznajmljivanja vozila.',
    please_do_the_following: 'Uradite sljedeće',
    remove_all_belonging_and_lock_the_vehicle: 'Uklonite sve svoje predmete iz vozila i zaključajte ga.',
    lock_vehicle: 'Zaključajte vozilo',
    once_you_have_contacted_customer_services: 'Kada se obratite korisničkoj službi',
    vehicle_location: 'Lokacija vozila',
    collect_your: 'Preuzmite',
    from: 'Od',
    key_in_glove_box: 'vaš se ključ nalazi u pretincu za rukavice',

    keyholder: {
      not_detected: 'Key not detected in keyholder',
      not_detected_please_try_again: 'Please place your key in the keyholder, and then try again.',

      not_installed: 'Keyholder not installed',
      not_installed_please_contact_customer_service: 'Keyholder is not installed, please contact customer service.',
    },
    keyring: {
      look_up_failed: 'Keyring look up failed',
      look_up_failed_please_contact_customer_service: 'Keyring look up faled, please contact customer service.',
    },
    key: {
      invalid: 'Key is invalid',
      invalid_please_contact_customer_service: 'Your key is invalid, please contact customer service.',

      expired: 'Key has expired',
      expired__please_contact_customer_service: 'Your key has expired, please contact customer service.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Recite nam gdje ste parkirali vozilo.',
    fuel_and_milage: 'Količina goriva i kilometraža',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Potvrđujete vrednosti kilometraže i količine goriva kada se završi iznajmljivanje vozila.',
    inspect: 'Provjera',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Zatražićemo vam po jednu fotografiju vozila iz sva četiri ugla, kao i svakog novog oštećenja koje se desilo u toku iznajmljivanja.',
    lock: 'Zaključajte',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Provjerite da li ste zaboravili nešto u vozilu i zatim ga zaključajte.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Recite nam gdje ste parkirali vozilo',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kada se vozilo zaključa, više nećete moći da ga otključate.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, provjerite da niste ostavili stvari, zaključajte vozilo i po potrebi vratite fizički ključ na držač ključeva.',
    lock_vehicle: 'Zaključajte vozilo',
    complete_check_in: 'Dovrši vraćanje vozila',
    inspection: 'Pregled',
    complete_vehicle_check_in: 'Dovršite vraćanje vozila',
    we_are_unable_to_complete_your_vehicle_check_in: 'Nismo uspjeli da dovršimo vraćanje vozila.',
    please_contact_customer_services: 'Obratite se korisničkoj službi',
    once_you_have_contacted_customer_services: 'Kada se obratite korisničkoj službi'
  },
  rental_agreement: {
    rental_agreement: 'Ugovor o iznajmljivanju',
    agreement_between: 'Ugovor zaključen između',
    and: 'i',
    sign_rental_agreement: 'Potpišite ugovor o iznajmljivanju',
    i_have_read_and_understood_the_terms_and_conditions: 'Pročitao sam i shvatio Uslovi i odredbe i prihvatio stanje vozila'
  },
  full_insurance_no_deposit: 'Potpuno osiguranje i nije potreban depozit',
  excess: '{amount} višak',
  deposit: '{amount} depozit',
  included_daily_distance: '{distance} {unit} dnevno',
  miles: 'milja',
  kilometers: 'kilometara',
  collection_details_title: 'Detalji kolekcije',
  collection_details_not_found: 'Za ovu lokaciju nisu definirani detalji kolekcije',
  free_cancellation: 'bESPLATNO otkazivanje',
  no_deposit: 'bez depozita',
  benefit_from: 'Korist od',
  for_only_per_day: 'Samo {price} po danu',
  upgrade_mee: 'UpgradeMee'
}
